import React, { useState } from 'react'

/**
 * Animated frog mascot rendered with the provided PNG asset.
 * Click/tap the frog to make it roll to the other side and rock back and forth.
 */
export function FrogMascot() {
  const [isRocking, setIsRocking] = useState(false)
  const [isOnRight, setIsOnRight] = useState(false)

  const handleFrogClick = () => {
    // Toggle between rocking state and rolling state
    if (isRocking) {
      // If rocking, roll to the other side
      setIsRocking(false)
      setIsOnRight(!isOnRight)
      // After rolling animation completes, start rocking
      setTimeout(() => {
        setIsRocking(true)
      }, 3000) // Duration of roll animation
    } else {
      // If not rocking, just roll to other side and start rocking
      setIsOnRight(!isOnRight)
      setTimeout(() => {
        setIsRocking(true)
      }, 3000)
    }
  }

  return (
    <div className="frog-mascot-wrapper" aria-hidden="true">
      <div className="frog-track">
        <span className="frog-track-line" />
        <img
          className={`frog-mascot ${isRocking ? 'frog-rocking' : ''} ${isOnRight ? 'frog-on-right' : 'frog-on-left'}`}
          src="/frogicon.png"
          alt="Friendly frog mascot"
          draggable={false}
          onClick={handleFrogClick}
          style={{ cursor: 'pointer', pointerEvents: 'auto' }}
        />
      </div>
    </div>
  )
}
